import { useTranslation } from 'react-i18next';
import './important-info-box.component.scss';

export const ImportantInfoBox: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className="important-info-box">
            <div className="important-info-box__icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                    <path d="M11 7V12M11 15V15.01M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z" stroke="#007AFF" strokeWidth="2" strokeLinecap="round"/>
                </svg>
            </div>
            <div className="important-info-box__content">
                <h4 className="important-info-box__title">{t('Important')}</h4>
                <p className="important-info-box__text">
                    {t('All information you enter in the Employer Certificate will appear in Swedish in the final certificate.')}
                </p>
            </div>
        </div>
    );
};
